<template>
  <v-card
    dark
    class="pa-2"
    width="100%"
    color="rgba(0,0,0,0.3)"
    style="border: 1px solid #757575"
  >
    <h5 class="text-center mb-1">発表中の警報・注意報</h5>
    <v-row no-gutters align="center">
      <template v-if="alerts.length > 0">
        <v-chip
          v-for="alert in alerts"
          :key="alert"
          :color="getAlertColor(alert)"
          :text-color="getAlertColor(alert) === 'warning' ? 'black' : null"
          small
          class="mr-1 mb-1"
        >
          {{ alert }}
        </v-chip>
      </template>
      <template v-else>
        <div class="text-center" style="width: 100%">
          なし
        </div>
      </template>
    </v-row>
  </v-card>
</template>
<script>
import { getAlertColor } from "../utils/common";
export default {
  name: "WarningStatus",
  data() {
    return {
      getAlertColor
    };
  },
  computed: {
    alerts() {
      return this.$store.getters.alertStatus;
    }
  }
};
</script>
